// extracted by mini-css-extract-plugin
export default {"container":"container_container__gupxJ","containerBody":"container_containerBody__A5Qs9"};